import moment from 'moment'

export const cardFilterByDates = (array, fromDate, toDate) => {
  if (!array) return
  return array.filter(
    (card) =>
      moment(card.createdDate.seconds * 1000).isSameOrAfter(moment(fromDate).startOf('day')) &&
      moment(card.createdDate.seconds * 1000).isSameOrBefore(moment(toDate).endOf('day'))
  )
}

export const cardFilterById = (array, searchTerm) => {
  if (!array) return

  return array.filter((card) =>
    card.id.toString().toUpperCase().includes(searchTerm.trim('^').toUpperCase())
  )
}

const getDescendantLocationIds = (locationId, locations = []) => {
  if (!locationId || !locations.length) return new Set()

  const descendantIds = new Set([locationId])
  const queue = [locationId]

  while (queue.length > 0) {
    const currentId = queue.shift()
    locations.forEach((loc) => {
      if (loc?.parentRef?.id === currentId && !descendantIds.has(loc.id)) {
        descendantIds.add(loc.id)
        queue.push(loc.id)
      }
    })
  }

  return descendantIds
}

export const cardFilterByLocation = (array, location, locations = []) => {
  if (!array) return []
  if (!location) return array

  const validLocationIds = getDescendantLocationIds(location, locations)

  return array
    .filter((item) => {
      if (validLocationIds.has(item?.locationRef?.id)) return item
      return null
    })
    .filter((el) => el !== null)
}

export const cardFilterByResponsible = (array, responsibleId) => {
  if (!array) return

  return array
    .filter((item) => {
      if (responsibleId === item?.responsible?.id) return item
      return null
    })
    .filter((el) => el !== null)
}

export const cardFilterByType = (array, type) => {
  if (!array) return
  return array
    .filter((item) => {
      if (item.type === type) return item
      return null
    })
    .filter((el) => el !== null)
}

export const cardFilterByStatus = (array, status) => {
  if (!array) return
  return array
    .filter((item) => {
      if (item?.status === status) return item
      return null
    })
    .filter((el) => el !== null)
}

export const cardFilterByCreatedBy = (array, createdBy) => {
  if (!array) return
  return array
    .filter((item) => {
      if (item?.createdByRef?.id === createdBy) return item
      return null
    })
    .filter((el) => el !== null)
}

export const cardFilterByAnomaly = (array, anomaly) => {
  if (!array) return
  return array
    .filter((item) => {
      if (item?.anomaliesRefs?.some((ref) => ref.id === anomaly)) {
        return item
      }
      return null
    })
    .filter((el) => el !== null)
}

export const cardFilterByOtStatus = (array, otStatus) => {
  if (!array) return
  return array
    .filter((item) => {
      if (item?.otStatus === otStatus) return item
      return null
    })
    .filter((el) => el !== null)
}
